<template>
  <FormDocument type="Devis" api-type="quotes" :edit_doc_number="doc_number" />
</template>

<script>
import FormDocument from '@/components/Form/Document'
export default {
  props: {
    doc_number: [String, Number],
  },
  components: {
    FormDocument,
  },
  theme() {
    return {
      title: 'Modifier devis',
      subtitle: '',
    }
  },
}
</script>

<style></style>
